import PropTypes from 'prop-types';
import React from 'react';
import { ErrorMessage } from '../common/ErrorMessage.js';
import { SubmitButton } from '../common/SubmitButton.js';
import { AjaxErrorMessageShape } from '../common/ErrorMessageConstants.js';
import { hasSigninError } from '../common/ErrorMessageUtils.js';
import { bindMethods } from '../common/classUtils.js';
import { SchoolSearch } from '../common/SchoolSearch.js';
import { serializeJQueryForm } from '../utils/ajaxUtils';

const PrincipalsSignupErrorsShape = PropTypes.shape({
    hasErrors: PropTypes.boolean,
    email: PropTypes.arrayOf(AjaxErrorMessageShape),
    fullName: PropTypes.arrayOf(AjaxErrorMessageShape),
    schoolId: PropTypes.arrayOf(AjaxErrorMessageShape),
    hasPrincipalSchoolRole: PropTypes.arrayOf(AjaxErrorMessageShape),
    global: PropTypes.arrayOf(AjaxErrorMessageShape),
});

const isFullName = (name) => {
    return name && name.trim().split(/\s+/).length > 1;
};

export class PrincipalsSignupSurvey extends React.PureComponent {
    constructor(props) {
        // Required step: always call the parent class' constructor
        super(props);

        this.state = {
            errorMessages: this.props.errorMessages,
            disabled: this.props.disabled,
            loading: this.props.loading,
            location: null,
            success: false,
        };

        bindMethods(this);
    }

    componentDidMount() {
        $(document).trigger('updateFirstSectionPosition');
    }

    validateForm(event) {
        const data = this.getFormValues();

        data.errorMessages = {};
        let disabled;

        // hasErrors
        if (!data.email || !data.fullName || !data.schoolId || !window.isEmailAddress(data.email)) {
            data.errorMessages.hasErrors = true;
            disabled = true;
        } else {
            data.errorMessages.hasErrors = false;
            disabled = false;
        }

        // update messages
        if (data.email && window.isEmailAddress(data.email)) {
            data.errorMessages.email = [];
        } else {
            data.errorMessages.email = (this.state.errorMessages && this.state.errorMessages.email) ? this.state.errorMessages.email : [];
        }

        if (data.schoolId) {
            data.errorMessages.schoolId = [];
        } else {
            data.errorMessages.schoolId = (this.state.errorMessages && this.state.errorMessages.schoolId) ? this.state.errorMessages.schoolId : [];
        }

        if (data.fullName && isFullName(data.fullName)) {
            data.errorMessages.fullName = [];
        } else if (data.fullName && !isFullName(data.fullName)) {
            data.errorMessages.fullName = [{
                field: 'fullName',
                code: 'fullname.missing',
                message: 'Please include your full name.',
            }];
        } else {
            data.errorMessages.fullName = (this.state.errorMessages && this.state.errorMessages.fullName) ? this.state.errorMessages.fullName : [];
        }

        if (data.receiveProjectPostedEmails || data.receiveFundingOpportunityEmails) {
            data.errorMessages.receiveProjectPostedEmails = [];
            data.errorMessages.receiveFundingOpportunityEmails = [];
        } else {
            data.errorMessages.receiveProjectPostedEmails = (this.state.errorMessages && this.state.errorMessages.receiveProjectPostedEmails) ? this.state.errorMessages.receiveProjectPostedEmails : [];
            data.errorMessages.receiveFundingOpportunityEmails = (this.state.errorMessages && this.state.errorMessages.receiveFundingOpportunityEmails) ? this.state.errorMessages.receiveFundingOpportunityEmails : [];
        }
        this.setState({
            errorMessages: data.errorMessages,
            disabled,
            success: false,
        });
    }

    toggleLoadingDots() {
        this.setState(prevState => ({ loading: !prevState.loading }));
    }

    setErrorMessages(errorMessages) {
        this.setState({ errorMessages });
    }

    setGenericErrorMessage() {
        const messages = {
            global: [{
                field: 'global',
                code: 'error.unknown',
                message: 'Your changes could not be saved.  Reload the page and try again later.',
            }],
            hasErrors: true,
        };
        this.setErrorMessages(messages);
    }

    setLocation(location) {
        this.setState({
            location,
        });
    }

    clearSelectedSchool() {
        this.setSelectedSchool(null);
    }

    setSelectedSchool(schoolId) {
        this.setState({ schoolId });
        this.validateForm();
    }

    disableSubmitButton() {
        if (this.state.errorMessages && this.state.errorMessages.hasErrors) {
            this.setState({ disabled: true });
        } else {
            this.setState({ disabled: false });
        }
    }

    // override the default behavior of "Still don't see your school"
    setShowNewSchoolRequestForm() {
        window.open(secureBaseURL + 'help/donor_contact_form.html?supportCategory=3860&message=Missing%20School', '_blank');
    }

    renderSchoolSearch() {
        return (

            <SchoolSearch
                userFullName={this.props.fullName}
                userEmail={this.props.email}
                isTeacherRegistrationRequest={false}
                location={this.state.location}
                setLocation={this.setLocation}
                setSelectedSchool={this.setSelectedSchool}
                clearSelectedSchool={this.clearSelectedSchool}
                setShowNewSchoolRequestForm={this.setShowNewSchoolRequestForm}
            />

        );
    }

    getFormValues() {
        const data = serializeJQueryForm('#principal-signup-form');
        data.schoolId = parseInt(this.state.schoolId);
        return data;
    }

    onSubmit(event) {
        event.preventDefault();

        this.validateForm();
        if (this.state.disabled) {
            return;
        }

        const data = this.getFormValues();
        this.toggleLoadingDots();

        // var component = this;
        $.ajax('/common/schoolrole_signup.html', {
            method: 'POST',
            contentType: 'application/json; charset=utf-8',
            dataType: 'json',
            data: JSON.stringify(data),
        }).done((response) => {
            if (response && response.data && response.data.success) {
                this.setState({
                    success: true,
                    disabled: true,
                });
            } else {
                if (hasSigninError(response.errors)) {
                    location.href = secureBaseURL + 'common/signin.html?go=' + encodeURIComponent(location.href);
                } else if (response && response.errors) {
                    const messages = response.errors;
                    messages.hasErrors = true;
                    this.setErrorMessages(messages);
                    this.disableSubmitButton();
                } else {
                    console.log('Failure!', response);
                    this.setGenericErrorMessage();
                }
            }
        }).fail((response) => {
            console.log('Failure!', response);
            this.setGenericErrorMessage();
        }).always(() => {
            this.toggleLoadingDots();
        });
    }

    renderSuccessMessage() {
        if (this.state.success) {
            return (
                <div className="alert-message success">
                    <div className="alert-text">
                        <strong>Success!</strong> Please allow a week for verification.
                    </div>
                </div>
            );
        }
        return null;
    }

    onClickUpdateSchoolInfoContactLink(event) {
        const data = this.getFormValues();
        if (data.schoolId) {
            let schoolMessage = `Principal school id: ${data.schoolId}`;
            const schoolName = $('.school-info').find('h3').text();
            if (schoolName) {
                schoolMessage += `\nPrincipal school name: ${schoolName}`;
            }
            const el = event.target;
            el.href = (new Uri(el.href)).replaceQueryParam('message', schoolMessage).toString();
        }
    }

    renderUpdateSchoolInfoContactLink() {
        const data = this.getFormValues();
        if (data.schoolId) {
            return (
                <div className="input-holder full-width close-top-margin">
                    <a target="_blank" rel="noopener noreferrer" onClick={this.onClickUpdateSchoolInfoContactLink}
                        href={secureBaseURL + 'help/donor_contact_form.html?supportCategory=3860'}>&raquo; Incorrect school details? Contact us</a>
                </div>
            );
        }
        return null;
    }

    render() {
        return (
            <div>
                <form id="principal-signup-form" className="form-redux principal-signup" onSubmit={this.onSubmit}>
                    <h3 ref={(r) => { this.searchHeader = r; }}>Get principal notifications for your&nbsp;school</h3>
                    <div className="input-holder full-width">
                        <label htmlFor="name">Full Name</label>
                        <input type="text" name="fullName" defaultValue={this.props.fullName} onChange={this.validateForm} />
                        <div><ErrorMessage errorMessages={this.state.errorMessages} fieldName="fullName" /></div>
                    </div>
                    <div className="input-holder full-width">
                        <label htmlFor="email">Email address</label>
                        <input type="email" name="email" defaultValue={this.props.email} onChange={this.validateForm} />
                        <div><ErrorMessage errorMessages={this.state.errorMessages} fieldName="email" /></div>
                    </div>
                    <div className="full-width">
                        <label htmlFor="schoolName">School name</label>
                        {this.renderSchoolSearch()}
                        <div><ErrorMessage errorMessages={this.state.errorMessages} fieldName="schoolId" /></div>
                    </div>
                    {this.renderUpdateSchoolInfoContactLink()}

                    <div className="input-holder radio-wrapper principal-radios">
                        <label>
                            <span className="radio">
                                <input type="radio" name="hasPrincipalSchoolRole" value="true" defaultChecked={this.props.hasPrincipalSchoolRole} />
                            </span>
                            I&lsquo;m the principal
                        </label>
                        <label>
                            <span className="radio">
                                <input type="radio" name="hasPrincipalSchoolRole" value="false" defaultChecked={!this.props.hasPrincipalSchoolRole} />
                            </span>
                            I&lsquo;m not the principal, but I&lsquo;m a leader at this school
                        </label>
                        <div><ErrorMessage errorMessages={this.state.errorMessages} fieldName="hasPrincipalSchoolRole" /></div>
                    </div>
                    <div className="input-holder checkbox-wrapper">
                        <label htmlFor="receiveProjectPostedEmails" className="checkbox">
                            <input type="checkbox" id="receiveProjectPostedEmails" name="receiveProjectPostedEmails" defaultChecked={this.props.receiveProjectPostedEmails} onChange={this.validateForm} />
                            Send me notices about projects posted at my school
                        </label>
                        <label htmlFor="receiveFundingOpportunityEmails" className="checkbox">
                            <input type="checkbox" id="receiveFundingOpportunityEmails" name="receiveFundingOpportunityEmails" defaultChecked={this.props.receiveFundingOpportunityEmails} onChange={this.validateForm} />
                            Send me notices about funding opportunities at my school
                        </label>
                        <p className="email-notice-materials-shipped">If you are the principal or leader for this school, you will receive notifications of materials shipped to your school.</p>
                    </div>

                    <div className="input-holder signup-wrapper">
                        {this.renderSuccessMessage()}
                        <div><ErrorMessage errorMessages={this.state.errorMessages} fieldName="global" /></div>
                        <SubmitButton disabled={this.state.disabled} loading={this.state.loading} buttonText="Get updates" />
                    </div>
                </form>
            </div>
        );
    }
}

PrincipalsSignupSurvey.propTypes = {
    isSignedIn: PropTypes.bool,
    email: PropTypes.string,
    fullName: PropTypes.string,
    schoolId: PropTypes.number,
    hasPrincipalSchoolRole: PropTypes.bool,
    receiveProjectPostedEmails: PropTypes.bool,
    receiveFundingOpportunityEmails: PropTypes.bool,
    errorMessages: PrincipalsSignupErrorsShape,
    disabled: PropTypes.bool,
    loading: PropTypes.bool,
    setSchoolId: PropTypes.func,
    setEmail: PropTypes.func,
    setFullName: PropTypes.func,
    toggleLoading: PropTypes.func,
    toggleDisabled: PropTypes.func,
};

PrincipalsSignupSurvey.defaultProps = {
    isSignedIn: false,
    hasPrincipalSchoolRole: true,
    receiveProjectPostedEmails: false,
    receiveFundingOpportunityEmails: false,
    disabled: false,
    loading: false,
};
